export * from './LicensePropertyAutocomplete.dde'
import { DDELicensePropertyAutocomplete } from './LicensePropertyAutocomplete.dde'
import { DGELicensePropertyAutocomplete } from './LicensePropertyAutocomplete.dge'

export const LicensePropertyAutocomplete = {
  DDE: DDELicensePropertyAutocomplete,
  DGE: DGELicensePropertyAutocomplete
}
